// extracted by mini-css-extract-plugin
export default {"root":"ErrorLayout_root__P-XSi"};